/**
 * Dependencies.
 */
import { isPlainObject } from 'lodash-es';
import Vue from 'vue';

import APP from '@/constants/application.constant';
import { ROUTES } from '@/constants/routes.constant';
import { partnershipIdRequestInterceptor } from '@/modules/social-network/utils/headers.util';

/**
 * Export `setupHTTP`.
 */
export const setupHTTP = (vueInstance: Vue) => {
  vueInstance.$kit.http.setupPrivateEndpoint((url) => {
    if (APP.auth && APP.auth.privateBaseUrl) {
      return (
        url.match(APP.auth.privateBaseUrl) !== null ||
        url.match(APP.baseRestUrl) !== null ||
        url.match('graphql') !== null ||
        url.match(APP.socialNetworkMediaUrl) !== null ||
        url.match(APP.socialNetworkCropUrl) !== null
      );
    }

    return false;
  });

  vueInstance.$kit.http.setupBaseUrl(APP.baseUrl);

  vueInstance.$kit.http.addRequestInterceptor(partnershipIdRequestInterceptor);

  /**
   * Graphql operation request interceptor.
   */
  vueInstance.$kit.http.addRequestInterceptor((config) => {
    if (
      config.url &&
      new URL(
        config.url,
        config.baseURL || window.location.origin
      ).pathname.endsWith('/graphql')
    ) {
      let operation = 'null';

      if (isPlainObject(config.data)) {
        operation = config.data.operationName || 'null';
      }

      config = {
        ...config,
        params: {
          ...config.params,
          operation
        }
      };
    }

    return config;
  });

  vueInstance.$kit.$http.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.toString().indexOf('status code 403') !== -1) {
        vueInstance.$router.push({
          name: ROUTES.APP.UNAUTHORIZED
        });
      }
      return Promise.reject({ ...error });
    }
  );
};
